import React from 'react';
import GDLoadingBlock from './block/gd-loading-block';
import {toggleClass} from "../../../gd/utils/dom-and-react/react-utils";

export default class GDLoadingOverlap extends React.Component<any, any> {

    showLoading = (value:boolean) => {
        toggleClass(this,"is-visible", value)
    }

    render() {
        return (
            <div className="gd-loading-overlap">
                <GDLoadingBlock />
            </div>
        );
    }
}
